<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CjvYHk/tc-custom/cover.jpg?1684306111258?1706297159286" alt="This image is the cover for the book It's Time to Step Up!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">It's Time to Step Up!
      </h1>
      <p class="bookDescription body article font2">
        <p>If your goal is to lead your team to operate at the highest possible level, It’s Time to Step Up! will help you achieve that goal. Sound strategy and tactics are also needed when motivating people, building morale, critiquing under performing team members, mentoring new ones, delegating tasks, and making consistent progress as a team.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frank Viscuso
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      PennWell
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c3634cb4